module.exports = __webpack_public_path__ + "img/thumbnail_Hippopotamus_f_normal.e3d6c4f8.png";